import CarouselWithIndex from "components/app/carousel-with-index/CarouselWithIndex";
import ImageHoverPlay from "components/app/image-hover-play/ImageHoverPlay";
import StatusHoverPlay from "components/app/status-hover-play/StatusHoverPlay";
import VideoHoverPlay from "components/app/video-hover-play/VideoHoverPlay";
import { useNavigate } from "react-router-dom";
import { RouteUrl } from "utils";

export default function ProfileMediaContent({ post }: { post: any }) {
  const navigate = useNavigate();

  const onGoToPost = (postId: string) => {
    navigate(`${RouteUrl.profilePostContentsPageView}?post_id=${postId}`);
  };

  const hasAttachments = post?.post_attachments?.length > 0;

  const renderMediaContent = () => {
    if (!post || !hasAttachments) {
      return <img src="https://via.placeholder.com/150x300" className="w-full h-auto rounded-lg" alt="" />;
    }

    const commonProps = {
      className: "relative cursor-pointer",
      onClick: () => onGoToPost(post.post_id),
    };

    switch (post.media_type) {
      case "photo":
        return (
          <div {...commonProps}>
            <ImageHoverPlay post={post} />
          </div>
        );
      case "album":
        return (
          <div {...commonProps}>
            <CarouselWithIndex item={post} imgClassName="w-full h-auto object-cover rounded-lg" indexClassName="" />
          </div>
        );
      case "video":
        return (
          <div {...commonProps}>
            <VideoHoverPlay post={post} />
          </div>
        );
      case "status":
        return (
          <div {...commonProps}>
            <StatusHoverPlay post={post} />
          </div>
        );
      default:
        return <img src="https://placehold.co/150x300" className="w-full h-auto rounded-lg" alt="" />;
    }
  };

  return <>{renderMediaContent()}</>;
}
